import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const GenerateClientInductionReport = (apiData) => async (dispatch) => {  
  try {
    const response = await axios({
      method: "get", // Change GET to POST
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
      },
      url: `${actionType.environment_url}/api/admin/client/GenerateClientInductionReport`,
      params: {
        ...apiData,
        client_org_ids: JSON.stringify(
          apiData.client_org_ids?.map((item) => item?.organisation_id)
        ),
        provider_org_ids: JSON.stringify(
          apiData.provider_org_ids?.map((item) => item?.provider_org_id)
        ),
        com_ind_ids: JSON.stringify(
          apiData.com_ind_ids?.map((item) => item?.induction_id)
        ),
        site_ind_ids: JSON.stringify(
          apiData.site_ind_ids?.map((item) => item?.induction_id)
        ),
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};
